<template>
  <div class="container">
    <h1 class="mb-4">Overview</h1>
    <div class="row justify-content-center">
      <div v-for="link in links" :key="link.id"
        class="col-md-4 d-flex justify-content-center align-items-stretch">
        <Card :name="link.title" @click="viewQuestion(link.id)" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import router from '@/router';
import { Link } from '@/services/client/types';
import { useAuthStore } from '@/stores/authStore';
import { useLinkStore } from '@/stores/linkStore';
import { useUserStore } from '@/stores/userStore';
import { onMounted, ref } from 'vue';
import Card from '../components/Card.vue';

// Stores
const authStore = useAuthStore()
const userStore = useUserStore()
const linkStore = useLinkStore()

const links = ref<Link[]>([])

onMounted(async () => {
  console.log(`Requesting user links...`)
  if (!authStore.user?.id) throw new Error(`Could not find user data in authStore. User is possibly unauthenticated. Reset your cache.`);
  const userId = authStore.user.id
  const user = await userStore.getUser(userId)
  if (!user) throw new Error(`Could not retrieve user data from userStore. Try to reset your cache.`);
  links.value = await linkStore.fetchLinksForUser(user)
  console.log(`Received links: `, links)
})

console.log("Links in store:", links)

function viewQuestion(id: number) {
  console.log('Viewing data for question:', id);
  router.push(`/data/${id}?no_container=true`) // Set to false to set default behaviour for showing container to false
  // Navigate or fetch data for the question
}
</script>

<style scoped>
/* Optional: Add padding/margin to improve spacing when cards are centered */
.row {
  margin-top: 20px;
}

.col-md-4 {
  margin-bottom: 20px;
}
</style>